import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClassificationApplicantsTypesAction } from "../actions";
import { getLoading, getData } from "../selectors";
import { getAppColor } from "@icarius-app/selectors";
import { Grid } from "@material-ui/core";
import DataItem from "./data/dataItem";
import { RESET_STATE } from "../actionTypes";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import paths from "@icarius-router/paths";
import { getTheme } from "@icarius-pages/login/selectors";
import { getLocalizedString } from "@icarius-localization/strings";

const ClassificationApplicantsTypes = ({ history }) => {
    const [createIsOpen, setCreateIsOpen] = useState(false);

    const dispatch = useDispatch();
    const color = useSelector(getAppColor);
    const data = useSelector(getData);
    const isLoading = useSelector(getLoading);
    const gridTheme = useSelector(getTheme);

    useEffect(() => {
        dispatch(getClassificationApplicantsTypesAction());
        return () => {
            dispatch({ type: RESET_STATE });
        };
    }, [dispatch]);

    const getDataIsEmpty = () => {
        return !data || data.length === 0;
    };

    const handleGoBack = () => {
        history.push(paths.talentAcquisitionSettings);
    };

    return (
        <ABMLayout
            title={getLocalizedString("classificationApplicantsTypes")}
            isLoading={isLoading}
            showCreateButton={!createIsOpen}
            createButtonTitle={getLocalizedString("newClassificationType")}
            createButtonOnClick={() => setCreateIsOpen(true)}
            showNoData={getDataIsEmpty()}
            noDataTitle={getLocalizedString("noClassificationTypesFound")}
            noDataCreateTitle={getLocalizedString("newClassificationType")}
            noDataOnClick={() => setCreateIsOpen(true)}
            showGoBack
            handleGoBack={handleGoBack}
        >
            {createIsOpen && (
                <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                    <DataItem gridTheme={gridTheme} color={color} data={null} closeNew={() => setCreateIsOpen(false)} />
                </Grid>
            )}
            {data &&
                data.map((item) => {
                    return (
                        <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.code}>
                            <DataItem data={item} color={color} gridTheme={gridTheme} />
                        </Grid>
                    );
                })}
        </ABMLayout>
    );
};

export default ClassificationApplicantsTypes;
